import successCheckmark from "@/assets/success_checkmark.svg";

export const SuccessCheckmark = ()  => {
  return (
    <img alt="Success" src={successCheckmark} style={{ width: 241, height: 241 }} />
  );
};